var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"video_playback"},[_c('button',{staticClass:"video_playback_close",on:{"click":_vm.closeDetail}},[_vm._v("×")]),_c('video',{staticClass:"video_content",attrs:{"src":_vm.videoUrl,"controls":"","autoplay":"","muted":"","loop":""},domProps:{"muted":true}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }